export default __webpack_public_path__ + "static/media/seniorkoncept_header.ee274479.jpg";